import React from 'react';
import './ProductCategories.css';
import nose from '../images/noses.jpg';
import eye from '../images/eyes.jpg';
import { Link } from 'react-router-dom';

const ProductCategories = () => {
  return (
    <section className="product-categories">

      {/* 🔥 MAIN HEADING */}
      <h1 className="product-categories-title">
        Plastic Safety Eyes & Toy Nose Manufacturer in India
      </h1>

      {/* 🔥 SEO SUBTEXT */}
      <p className="product-categories-subtitle">
        Pushkar Enterprises is a trusted <strong>manufacturer of plastic safety eyes and toy noses </strong> 
         for <strong>soft toys, plush toys, and stuffed animals</strong>. 
        We supply high-quality components in <strong>bulk across India</strong>.
      </p>

      <div className="category-grid">

        {/* 🔥 EYES CATEGORY */}
        <article className="product-category">

          <Link to="/eyes" className="no-underline">

            <div className="image-container">
              <img 
                src={eye} 
                alt="plastic safety eyes for soft toys manufacturer India bulk supply" 
                className="product-image"
                loading="lazy"
              />
              <div className="image-overlay">View Products</div>
            </div>

            <h2 className="category-title">
              Plastic Safety Eyes
            </h2>

            <p className="category-description">
              Explore our range of <strong>plastic safety eyes for soft toys</strong>, 
              including <strong>crystal eyes, sparkle eyes, and button eyes</strong>. 
              Ideal for manufacturers, exporters, and bulk buyers.
            </p>

          </Link>
        </article>

        {/* 🔥 NOSE CATEGORY */}
        <article className="product-category">

          <Link to="/nose" className="no-underline">

            <div className="image-container">
              <img 
                src={nose} 
                alt="plastic toy noses supplier India teddy bear nose bulk manufacturer" 
                className="product-image"
                loading="lazy"
              />
              <div className="image-overlay">View Products</div>
            </div>

            <h2 className="category-title">
              Plastic Toy Noses
            </h2>

            <p className="category-description">
              High-quality <strong>plastic toy noses</strong> for teddy bears, dolls, and plush toys. 
              Available in multiple sizes and designs for <strong>bulk orders</strong>.
            </p>

          </Link>
        </article>

      </div>

      {/* 🔥 EXTRA SEO CONTENT */}
      <div style={{ maxWidth: "900px", margin: "30px auto", textAlign: "center" }}>
        <h2>Bulk Supply of Soft Toy Accessories in India</h2>

        <p>
          We specialize in manufacturing and supplying <strong>soft toy accessories</strong> including 
          plastic eyes and noses. With over 25 years of experience, we provide reliable quality, 
          competitive pricing, and fast delivery across India.
        </p>

        <p>
          <a href="/contact" title="Contact for bulk orders of toy eyes and noses">
            Contact us for bulk inquiries →
          </a>
        </p>
      </div>

    </section>
  );
};

export default ProductCategories;